import "bootstrap/js/dist/tab";

export default function Tabs() {
  const tabsWrapper = document.querySelectorAll('.tabs_wrapper');
  const tabs = document.querySelectorAll('.tabs_wrapper .nav-link');
  var activeElement = document.querySelectorAll('.tabs_wrapper .nav-link.active');

  function showTabContentOnResize(element) {
    if(innerWidth < 992) {
      const content = element.parentNode && element.parentNode.parentNode && element.parentNode.parentNode.querySelector('.tab-content');
      element && element.parentNode.insertBefore(content && content, element.nextSibling);
    }
    else {
      tabsWrapper && tabsWrapper.forEach((wrapper) => {
        const wrapperContent = wrapper.querySelector('.tab-content');
        wrapper && wrapper.appendChild(wrapperContent && wrapperContent);
      });
    }
  }

  activeElement && activeElement.forEach((el) => {
    showTabContentOnResize(el);
  });    

  window.onresize = function () {
    activeElement = document.querySelectorAll('.tabs_wrapper .nav-link.active');
    activeElement && activeElement.forEach((el) => {
      showTabContentOnResize(el);
    });    
  };


  tabs && tabs.forEach((tab) => {    
    tab.addEventListener('click', (e) => {
      showTabContentOnResize(e.target);
    })
  });
}
